import React from 'react'

function InfoCircleIcon({color = "currentColor", size = 26, ...rest }) {
    return (
        <svg {...rest} width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_7227_15895)">
                <path d="M7.18359 10.4199L7.01953 5.55078V4.05664H8.0625V5.55078L7.9043 10.4199H7.18359ZM7.54102 12.6289C7.29102 12.6289 7.10742 12.5781 6.99023 12.4766C6.87695 12.375 6.82031 12.1953 6.82031 11.9375C6.82031 11.6797 6.87695 11.5 6.99023 11.3984C7.10742 11.2969 7.29102 11.2461 7.54102 11.2461C7.79492 11.2461 7.97852 11.2969 8.0918 11.3984C8.20508 11.5 8.26172 11.6797 8.26172 11.9375C8.26172 12.1953 8.20508 12.375 8.0918 12.4766C7.97852 12.5781 7.79492 12.6289 7.54102 12.6289Z" fill={color} />
            </g>
            <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" stroke={color} />
            <defs>
                <clipPath id="clip0_7227_15895">
                    <rect width={size} height={size} rx="8" fill="white" />
                </clipPath>
            </defs>
        </svg>


    )
}

export default InfoCircleIcon